module.exports = __webpack_public_path__ + "img/pp.d9fc734b.png";